var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommonService } from './Services/Common/CommonService';
import { NotificationsService } from './Services/Notifications/NotificationService';
import { Api } from 'lavva.exalushome/build/js/Api';
import { DependencyContainer } from 'lavva.exalushome/build/js/DependencyContainer';
import { LoggerService } from 'lavva.exalushome/build/js/Services/Logging/LoggerService';
import { ThemesService } from './Services/Themes/ThemesService';
export class NativeWebViewFunctions {
    constructor() {
        this._services = new Map();
    }
    GetServiceName() {
        return NativeWebViewFunctions.ServiceName;
    }
    static Init() {
        DependencyContainer.Instance.RegisterService(new NativeWebViewFunctions());
        Api.Get(LoggerService.ServiceName).Debug("Initialized WebViewFunctions service (native support for ios or android webview)");
    }
    GetNativeFunctionServiceByServiceType(classType) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.getServiceAsync(classType);
        });
    }
    getServiceAsync(serviceName) {
        return __awaiter(this, void 0, void 0, function* () {
            const srv = this._services.get(serviceName);
            if (srv != null) {
                return srv;
            }
            else {
                let srv;
                switch (serviceName) {
                    case CommonService.ServiceName:
                        srv = new (yield import('./Services/Common/CommonService')).CommonService();
                        break;
                    case NotificationsService.ServiceName:
                        srv = new (yield import('./Services/Notifications/NotificationService')).NotificationsService();
                        break;
                    case ThemesService.ServiceName:
                        srv = new (yield import('./Services/Themes/ThemesService')).ThemesService();
                        break;
                    default:
                        throw new CannotLoadServiceError(`Cannot load service, unsupported service`, serviceName);
                }
                if (srv == null)
                    throw new CannotLoadServiceError(`Cannot load service, not found implementation`, serviceName);
                this._services.set(serviceName, srv);
                return srv;
            }
        });
    }
}
NativeWebViewFunctions.ServiceName = "NativeWebViewFunctionsService";
class CannotLoadServiceError extends Error {
    constructor(message, serviceName) {
        super(message);
        this.message = message;
        this.serviceName = "";
        this.name = "CannotLoadServiceError";
        this.serviceName = serviceName;
    }
}
//# sourceMappingURL=WebViewFunctions.js.map